import { useDiagramContext } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/contexts/DiagramContext';

interface DiagramStopProps {
  x: number;
  y: number;
}

export const DiagramStop = ({ x, y }: DiagramStopProps) => {
  const { colors } = useDiagramContext();

  return (
    <>
      <line x1={x} y1={y} x2={x} y2={y + 34} stroke={colors.stop} strokeWidth={3} />
      <text x={x} y={y - 6} textAnchor="middle" fill={colors.stop} fontSize={9.5} fontWeight={700}>
        STOP
      </text>
    </>
  );
};
